import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

/**
 * Base skeleton block — a shimmering placeholder. Compose freely to build
 * page-shaped loading states, e.g. `<Skeleton className="h-4 w-32" />`.
 * Uses the theme's inset tone (panel-2) so it sits naturally on cards/canvas.
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse rounded-md bg-panel-2", className)} {...props} />;
}

export default Skeleton;
